(function($, d) {
	'use strict';
	$(function() {
		$('#id-input-name').on("input", function() {
			if ($(this).val().length > 0) {

				let friendNameInput = $(this).val().trim().split(" "),
					friendNameSanitized = [];

				for (let value of friendNameInput) {
					if (!new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(value)
						&& value) {
						friendNameSanitized.push(value);
					}
				}

				if ($(this).val().trim() !== friendNameSanitized.join(" ")) {
					$(this).val(friendNameSanitized.join(" "));
				}

			}
		});
	});
})(jQuery, document);